import ReactPlayer from 'react-player';
import ModalComponent from '../ModalComponent';
import { XamaLogo } from '../../assets/svgs/icons';
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next';

export const VideoModal = ({isOpen, videoUrl, onClose}) => {
  const {t}  = useTranslation()
  return (
    <ModalComponent
      isOpen={isOpen}
      style={{
        width: '668px',
        borderRadius: '30px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '60px ',
          gap: '10px',
        }}
      >
        <div>
          <XamaLogo width={108} height={32} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '668px',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              fontSize: '26px',
              fontWeight: '400',
              padding: '0 60px',
              marginTop: '0px',
            }}
          >
            {
              t('scheduling_post_video.title')
            }
          </h1>
        </div>
          
        <div>
          {videoUrl && (

            <ReactPlayer
              style={{
                marginBottom: 20,
              }}
              url={videoUrl}
              controls
              width={530}
              height={298}
            />
          )}
        </div>
          
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div
            onClick={onClose}
            style={{
              boxShadow: '0px 14px 40px 2px #6A009890',
          
              borderRadius: '40px',
            }}
          >
            <button
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                fontFamily: 'Poppins',
                background:
                              'linear-gradient(156.31deg, #6A0098 0%, #9F00E4 100%)',
                borderRadius: '40px',
                fontSize: '16px',
                fontWeight: '400',
                padding: '12px 30px ',
                boxShadow: '-3px 4px 13.9px 0px #FFFFFF59 inset',
              }}
            >
              {t('scheduling_post_video.button')}
            </button>
          </div>
        </div>
      </div>
    </ModalComponent>
  )
}

         
VideoModal.propTypes = {
  isOpen:PropTypes.bool,
  videoUrl:PropTypes.string,
  onClose:PropTypes.func
}
